import _regeneratorRuntime from "D:\\workFile\\qingbeiCode\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Timer from "@/components/ques/Timer.vue";
import AnswerSheet from "@/components/ques/AnswerSheet.vue";
export default {
  name: "ExamDoRight",
  components: {
    Timer: Timer,
    AnswerSheet: AnswerSheet
  },
  props: {
    testModel: {
      type: Boolean,
      default: false
    },
    hideSetting: {
      type: Boolean,
      default: false
    },
    limitTime: {
      type: Number,
      default: 0
    },
    reportId: {},
    scantron: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    hasSection: {
      type: Boolean,
      default: false
    },
    answer: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    current: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    storeKey: {
      type: String,
      default: "exam-seconds"
    },
    allowPause: {
      type: Boolean,
      default: true
    },
    hasNotSupport: {
      type: Boolean,
      default: true
    },
    shotAnswerEditable: {
      type: Boolean,
      default: false
    },
    submitTopicFunc: {
      type: Function
    },
    getTopicFunc: {
      type: Function
    }
  },
  data: function data() {
    return {
      index: 0,
      seconds: 0,
      hasInit: false
    };
  },
  computed: {
    total: function total() {
      return this.scantronQuestions.length;
    },
    answerCount: function answerCount() {
      return this.scantronQuestions.filter(function (q) {
        return q.status == 1 || q.status == 2;
      }).length;
    },
    scantronQuestions: function scantronQuestions() {
      if (!this.scantron.data) {
        return [];
      }

      if (this.hasSection) {
        var list = [];
        this.scantron.data.forEach(function (t) {
          t.child.forEach(function (ques) {
            list.push(ques);
          });
        });
        return list;
      } else {
        return this.scantron.data;
      }
    }
  },
  watch: {
    current: function current() {
      var _this = this;

      if (this.hasInit) {
        return;
      }

      this.seconds = (this.$storage().get(this.storeKey) || {})[this.reportId] || this.current.answer_time;
      this.$nextTick(function () {
        _this.$refs.timer.start();
      });
      this.hasInit = true;
    }
  },
  methods: {
    currentTime: function currentTime(val) {
      this.seconds = val;
      this.$emit("updateTime", val);
    },
    init: function init(index) {
      this.index = index;
      this.getTopic();
    },
    getTopic: function () {
      var _getTopic = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(index) {
        var params;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                index = index || this.index;
                params = {
                  reportId: this.reportId,
                  index: index
                };

                if (!this.getTopicFunc) {
                  _context.next = 7;
                  break;
                }

                _context.next = 5;
                return this.getTopicFunc(params);

              case 5:
                _context.next = 8;
                break;

              case 7:
                this.$emit("getTopic", params);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getTopic(_x) {
        return _getTopic.apply(this, arguments);
      }

      return getTopic;
    }(),
    submitTopic: function () {
      var _submitTopic = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var answer, params;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // 不支持简答题开发需求代码
                // if (!this.shotAnswerEditable && this.current.ques_type == 5) {
                //   return;
                // }
                answer = "";

                if (this.current.ques_type == 1 || this.current.ques_type == 2) {
                  answer = this.answer[this.current.question_id];
                } else if (this.current.ques_type == 3 || this.current.ques_type == 4) {
                  answer = this.answer[this.current.question_id].join(",");
                } else if (this.current.ques_type == 5) {
                  if (this.shotAnswerEditable) {
                    answer = this.answer[this.current.question_id];
                  }
                } else if (this.current.ques_type == 7) {
                  answer = this.answer[this.current.question_id].some(Boolean) ? this.answer[this.current.question_id].join("@@") : "";
                }

                params = {
                  report_id: this.reportId,
                  question_id: this.current.question_id,
                  user_answer: answer || "",
                  answer_time: this.seconds,
                  question: this.current
                };

                if (!this.submitTopicFunc) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 6;
                return this.submitTopicFunc(params);

              case 6:
                _context2.next = 9;
                break;

              case 8:
                this.$emit("submitTopic", params);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function submitTopic() {
        return _submitTopic.apply(this, arguments);
      }

      return submitTopic;
    }(),
    navPrev: function () {
      var _navPrev = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.index == 1)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                _context3.next = 4;
                return this.submitTopic();

              case 4:
                this.index--;
                _context3.next = 7;
                return this.getTopic();

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function navPrev() {
        return _navPrev.apply(this, arguments);
      }

      return navPrev;
    }(),
    navNext: function () {
      var _navNext = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this.index == this.total)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                _context4.next = 4;
                return this.submitTopic();

              case 4:
                this.index++;
                _context4.next = 7;
                return this.getTopic();

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function navNext() {
        return _navNext.apply(this, arguments);
      }

      return navNext;
    }(),
    goTo: function () {
      var _goTo = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(index) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.submitTopic();

              case 2:
                this.index = index;
                _context5.next = 5;
                return this.getTopic();

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function goTo(_x2) {
        return _goTo.apply(this, arguments);
      }

      return goTo;
    }(),
    submit: function () {
      var _submit = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var _this2 = this;

        var autoSubmit,
            count,
            store,
            _args6 = arguments;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                autoSubmit = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : false;
                _context6.next = 3;
                return this.submitTopic();

              case 3:
                if (autoSubmit) {
                  _context6.next = 13;
                  break;
                }

                this.$refs.timer.stop();
                count = this.scantronQuestions.filter(function (q) {
                  return q.status == 3;
                }).length;

                if (!(count > 0)) {
                  _context6.next = 11;
                  break;
                }

                _context6.next = 9;
                return this.$promiseConfirm("您还有" + count + "道题未做，确定要提交吗？", {
                  type: "warning",
                  customClass: "dialog-exam dialog-exam-progress",
                  confirmButtonText: "确定交卷",
                  cancelButtonText: "继续答题",
                  iconClass: "el-icon-question",
                  callback: function callback() {
                    _this2.$refs.timer.continue();
                  }
                });

              case 9:
                _context6.next = 13;
                break;

              case 11:
                _context6.next = 13;
                return this.$promiseConfirm("确定要提交吗？", {
                  type: "warning",
                  customClass: "dialog-exam dialog-exam-end",
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  iconClass: "el-icon-question",
                  callback: function callback() {
                    _this2.$refs.timer.continue();
                  }
                });

              case 13:
                store = this.$storage().get(this.storeKey) || {};
                delete store[this.id];
                this.$storage().set(this.storeKey, store);
                this.$emit("submit", {
                  id: this.reportId,
                  answer_time: this.seconds,
                  autoSubmit: autoSubmit
                });

              case 17:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function submit() {
        return _submit.apply(this, arguments);
      }

      return submit;
    }()
  }
};